import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('admin_token'));
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    verifyToken();
  }, [token]);

  const verifyToken = async () => {
    if (!token) {
      setIsAuthenticated(false);
      setLoading(false);
      return;
    }

    try {
      await axios.get(`${API}/admin/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setIsAuthenticated(true);
    } catch (err) {
      setToken(null);
      localStorage.removeItem('admin_token');
      setIsAuthenticated(false);
    }
    setLoading(false);
  };

  const login = async (username, password, captcha_id = null, captcha_answer = null) => {
    const data = { username, password };
    if (captcha_id && captcha_answer !== null) {
      data.captcha_id = captcha_id;
      data.captcha_answer = captcha_answer;
    }
    const response = await axios.post(`${API}/admin/login`, data);
    const { token: newToken } = response.data;
    setToken(newToken);
    localStorage.setItem('admin_token', newToken);
    setIsAuthenticated(true);
    return response.data;
  };

  const logout = async () => {
    if (token) {
      try {
        await axios.post(`${API}/admin/logout`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (err) {
        // Ignore logout errors
      }
    }
    setToken(null);
    localStorage.removeItem('admin_token');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
